import React, { PureComponent } from "react";
import fieldPropTypes from "./field-prop-types";
import selectedMapMarkerIcon from "../assets/images/map-marker-selected.png";
import {
  getFieldActionEventStates,
  actionEventsMap
} from "../screens/helpers/action-event-states";

const VIEW_SELECTOR_FIELD_NAME = "__viewSelector";

class MapViewField extends PureComponent {
  constructor(props) {
    super(props);
    this.markers = [];
    this.currentMarker = null;
  }

  componentWillUnmount() {
    this.markers.forEach(m => this.maps.event.clearInstanceListeners(m));
  }

  handleMarkerClick = pharmacy => {
    const fieldActionEvents = getFieldActionEventStates(
      this.props.field,
      actionEventsMap.onMarkerSelectEvent
    );
    this.props.appData.handleButtonClick(
      this.props.field.name,
      null,
      pharmacy,
      null,
      null,
      fieldActionEvents
    );
  };

  renderPharmacies = ({ map, maps }) => {
    this.maps = maps;
    const { pharmacies } = this.props.appData;
    const { selected } = pharmacies;
    const bounds = new maps.LatLngBounds();
    pharmacies.all.forEach(pharmacy => {
      const {
        "Address|Latitude": latitude,
        "Address|Longitude": longitude,
        StoreName: storeName,
        "Address|AddressLine1": address_line1,
        "Address|City": city,
        "Address|State": state,
        "Address|ZipCode": zipCode,
        distance
      } = pharmacy;
      const title = `${storeName}, ${address_line1}, ${city}, ${state} ${zipCode}, ${distance} mi`;

      const lat = parseFloat(latitude);
      const lng = parseFloat(longitude);
      const marker = new maps.Marker({ position: { lat, lng }, map, title });
      this.setSelectedMarkerIcon({ marker, pharmacy, selected });

      marker.addListener("click", () => {
        map.panTo(marker.getPosition());
        this.handleMarkerClick(pharmacy);

        if (this.currentMarker && this.currentMarker !== marker) {
          this.setMarkerIcon(this.currentMarker, null);
        }
        this.setMarkerIcon(marker, selectedMapMarkerIcon);
        this.currentMarker = marker;
      });
      this.markers.push(marker);
      bounds.extend(new maps.LatLng(lat, lng));
    });

    if (this.currentMarker) {
      setTimeout(() => {
        map.panTo(this.currentMarker.getPosition());
      }, 0);
    }

    map.fitBounds(bounds); // center map on selected marker
  };

  setSelectedMarkerIcon = ({ marker, pharmacy, selected }) => {
    if (selected && selected?.erx_vendor_id === pharmacy?.erx_vendor_id) {
      this.currentMarker = marker;
      this.setMarkerIcon(marker, selectedMapMarkerIcon);
      this.handleMarkerClick(pharmacy);
    }
  };

  setMarkerIcon = (marker, icon) => {
    marker.setIcon(icon);
  };

  renderPharmaciesList = () => {
    const {
      field: { name },
      appData: {
        pharmacies: { all: pharmacies },
        handleButtonClick,
        data: { screens },
        settings
      },
      components: { Address }
    } = this.props;
    const mapViewScreen = screens.find(
      screen =>
        (screen.params || "").includes("TDScreenOptionMapView") ||
        screen.name === "PharmacyMapTemplatedScreen"
    );
    const templateField = mapViewScreen?.data?.templated_list?.fields;
    const mappingRules = mapViewScreen?.data?.templated_list?.mapping;

    if (!templateField || !mappingRules) {
      return pharmacies.map(pharmacy =>
        (({
          StoreName: storeName,
          "Address|AddressLine1": address_line1,
          "Address|City": city,
          "Address|State": state,
          "Address|ZipCode": zipCode,
          distance,
          erx_vendor_id
        }) => (
          <li key={erx_vendor_id}>
            <Address
              name={storeName}
              address_line1={address_line1}
              city={city}
              state={state}
              zipCode={zipCode}
              distance={distance}
              onClick={() => handleButtonClick(name, pharmacy)}
              settings={settings}
            />
          </li>
        ))(pharmacy)
      );
    }
  };

  render() {
    const {
      appData: { values },
      components: { GMap }
    } = this.props;

    switch (values[VIEW_SELECTOR_FIELD_NAME]) {
      case "MAP":
        return (
          <div className='gmap-web-sdk'>
            <GMap renderLocations={this.renderPharmacies} />
          </div>
        );
      case "LIST":
        // eslint-disable-next-line jsx-a11y/no-redundant-roles
        return <ul role='list'>{this.renderPharmaciesList()}</ul>;
      default:
        break;
    }
    return null;
  }
}

MapViewField.propTypes = fieldPropTypes;

export default MapViewField;
